import React from 'react'
import Policies from '../components/Policies/Policies'
const PageNoteFound = () => {
  return (
    <>
    <Policies policyTitle={"404 Error"}/>
    <section className="main-content-sec">
<div className="container">
  <div className="row">
    <div className="col-lg-12">
      <div className="privacy-content">
       <h1 style={{textAlign:"center"}}>Page Not Found</h1>
      </div>
    </div>
  </div>
</div>
</section>
</>
  )
}

export default PageNoteFound